import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import { jsx } from '@emotion/react';

const StyledMenuOverlay = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: [],
  target: "e11d4ujq0"
} : {
  styleProps: [],
  target: "e11d4ujq0",
  label: "StyledMenuOverlay"
})(() => ({
  content: "''",
  position: "fixed",
  zIndex: -1,
  top: 0,
  left: 0,
  inlineSize: "100%",
  blockSize: "100%",
  bg: "utility.overlay"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lbnVPdmVybGF5LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHaUMiLCJmaWxlIjoiTWVudU92ZXJsYXkudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIE1vdXNlRXZlbnRIYW5kbGVyLCBIVE1MQXR0cmlidXRlcyB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHsgdGhlbWVkLCBTdHlsZVByb3BzIH0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVudU92ZXJsYXkgPSB0aGVtZWQoXCJkaXZcIiwge1xuICBzdHlsZVByb3BzOiBbXVxufSk8U3R5bGVQcm9wcz4oKCkgPT4gKHtcbiAgY29udGVudDogXCInJ1wiLFxuICBwb3NpdGlvbjogXCJmaXhlZFwiLFxuICB6SW5kZXg6IC0xLFxuICB0b3A6IDAsXG4gIGxlZnQ6IDAsXG4gIGlubGluZVNpemU6IFwiMTAwJVwiLFxuICBibG9ja1NpemU6IFwiMTAwJVwiLFxuICBiZzogXCJ1dGlsaXR5Lm92ZXJsYXlcIlxufSkpO1xuXG5pbnRlcmZhY2UgTWVudU92ZXJsYXlQcm9wcyBleHRlbmRzIFN0eWxlUHJvcHMsIEhUTUxBdHRyaWJ1dGVzPEhUTUxEaXZFbGVtZW50PiB7fVxuXG4vKipcbiAqIEBkZXByZWNhdGVkIFRoZSBgTWVudWAgY29tcG9uZW50IHdpbGwgYmUgcmVtb3ZlZCBpbiBJRkwgNy5cbiAqIFNlZSB0aGUgSUZMIDcgcHJlcGFyYXRpb24gZ3VpZGUgZm9yIG1vcmUgaW5mb3JtYXRpb246IGh0dHBzOi8vbGluay5pbmRlZWQudGVjaC9pZmwtNy1wcmVwLWd1aWRlXG4gKi9cblxuZXhwb3J0IGNvbnN0IE1lbnVPdmVybGF5ID0gZm9yd2FyZFJlZjxIVE1MRGl2RWxlbWVudCwgTWVudU92ZXJsYXlQcm9wcz4oXG4gICh7IG9uQ2xpY2ssIC4uLnByb3BzIH0sIHJlZikgPT4ge1xuICAgIGNvbnN0IGhhbmRsZU9uQ2xpY2s6IE1vdXNlRXZlbnRIYW5kbGVyPEhUTUxEaXZFbGVtZW50PiA9IGUgPT4ge1xuICAgICAgZS5zdG9wUHJvcGFnYXRpb24oKTtcbiAgICAgIGNvbnN0IGV2ZW50ID0gbmV3IE1vdXNlRXZlbnQoXCJtb3VzZWRvd25cIiwge1xuICAgICAgICBidWJibGVzOiB0cnVlXG4gICAgICB9KTtcblxuICAgICAgZG9jdW1lbnQuYm9keS5kaXNwYXRjaEV2ZW50KGV2ZW50KTtcblxuICAgICAgaWYgKG9uQ2xpY2spIHtcbiAgICAgICAgb25DbGljayhlKTtcbiAgICAgIH1cbiAgICB9O1xuXG4gICAgcmV0dXJuIDxTdHlsZWRNZW51T3ZlcmxheSByZWY9e3JlZn0gb25DbGljaz17aGFuZGxlT25DbGlja30gey4uLnByb3BzfSAvPjtcbiAgfVxuKTtcblxuTWVudU92ZXJsYXkuZGlzcGxheU5hbWUgPSBcIk1lbnVPdmVybGF5XCI7XG4iXX0= */");
/**
 * @deprecated The `Menu` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 */

const MenuOverlay = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    onClick,
    ...props
  } = _ref;
  const handleOnClick = e => {
    e.stopPropagation();
    const event = new MouseEvent("mousedown", {
      bubbles: true
    });
    document.body.dispatchEvent(event);
    if (onClick) {
      onClick(e);
    }
  };
  return jsx(StyledMenuOverlay, _extends({
    ref: ref,
    onClick: handleOnClick
  }, props));
});
MenuOverlay.displayName = "MenuOverlay";

export { MenuOverlay, StyledMenuOverlay };
